<!-- @veltra/icons generated sha256:2877c290ad63269a gen:8 source:src/svg/normal/clear.svg -->
<script setup lang="ts">
defineOptions({ name: 'Clear' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M7 4h2V2H7zm3-2v2h3a1 1 0 0 1 1 1v2a1 1 0 0 1-.859.99l.696 4.869a1 1 0 0 1-.99 1.141H3.153a1 1 0 0 1-.99-1.141L2.86 7.99A1 1 0 0 1 2 7V5a1 1 0 0 1 1-1h3V2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1m2.133 5H13V5H3v2zm0 1H3.867l-.714 5H5v-1.49c0-.277.228-.51.504-.51a.51.51 0 0 1 .496.51V13h1.5v-1.49c0-.277.228-.51.504-.51a.51.51 0 0 1 .496.51V13H10v-1.49c0-.277.228-.51.504-.51a.51.51 0 0 1 .496.51V13h1.847z"
    />
  </svg>
</template>
